import HomeOutlineFour from '@assets/icons/home-outline-four.svg'
import { Icon } from './Icon'

export const HomeOutlineFourIcon = Icon(HomeOutlineFour)
